<template>
  <el-dialog title="修改跟进状态" :visible.sync="visible" width="40%" :close-on-click-modal="false">
    <el-form :model="data"  ref="addForm" label-width="120px">
      <el-form-item label="跟进状态:">
        <el-radio-group v-model="data.followFlag">
          <el-radio :label="0" >未跟进</el-radio>
          <el-radio :label="1" >已跟进</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="描述:" prop="followDescription">
        <el-input
          type="textarea"
          :maxlength="200"
          v-model="data.followDescription"
          placeholder="请输入"
          clearable
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {applyFollow, applyUnfollowCount} from "@/api/system/tenant";

export default {
  name: "ApplyDialog",
  components: {
  },
  props: {},
  data() {
    return {
      visible: false,
      data: {
        followFlag:0,
        id:0,
        followDescription: ''
      },
      followFlag:0
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId,
      ...mapGetters(["permission_routes"])
    })
  },
  watch: {
    visible(val) {
      if (!val) {
        this.resetFormData();      }
    }
  },
  methods: {
    resetFormData () {
      this.resetForm("addForm");
      this.data.followDescription=''
    },
    open(data) {
      this.visible = true;
      this.resetFormData();
      this.data.id=data.id;
       this.data.followFlag=data.followFlag;
      this.data.followDescription=data.followDescription;
    },
    confirm() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading"
          });
          applyFollow(this.data)
            .then(response => {
              this.visible = false;
              this.$emit("success");
              this.msgSuccess('修改成功');
              this.updateBusinessNum()
            }).finally(() => {
              loading.close();
            });
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    /**
     * 更新菜单中的未更新数
     */
    updateBusinessNum() {
      // 目前只有两层菜单
      this.permission_routes.forEach(item => {
        if (item.children) {
          item.children.forEach(item2 => {
            // 租户申请，待跟进记录数
            if (item2.path === '/system/apply') {
              applyUnfollowCount().then(response => {
                  item2.businessNum = response.data
              })
            }
          })
        }
      })
    }
  }
};
</script>
